import { render, staticRenderFns } from "./SupplierAccountingEdit.vue?vue&type=template&id=158dd7a0&scoped=true"
import script from "./SupplierAccountingEdit.vue?vue&type=script&lang=js"
export * from "./SupplierAccountingEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158dd7a0",
  null
  
)

export default component.exports